import { color, ink } from "@styles";
import styled from "styled-components";
import Image from "next/image";
import { mobile } from "components/templates/Breakpoints";

export const Input = styled.input<{
  isOpen: boolean;
  $searchBarEmpty: boolean;
  $countrySelected: boolean;
}>`
  width: 100%;
  padding: ${(p) => (p.$countrySelected ? "1rem 4.4rem" : "1rem 1.5rem")};
  border: ${(p) =>
    p.$countrySelected
      ? `0.125rem solid ${ink.inkSubtle}`
      : `0.125rem solid ${ink.inkNonEssential}`};
  border-radius: 0.5rem;
  color: ${ink.inkBase};
  font-size: 1.25rem;
  line-height: 2rem;
  letter-spacing: 0.075rem;
  background: #fbfbfb;

  &::placeholder {
    color: ${ink.inkSubtle};
  }

  ${(p) =>
    p.isOpen &&
    `outline: none;
    border-bottom: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;`}

  ${(p) =>
    p.$searchBarEmpty &&
    `border-radius: 0.5rem;
    border: 0.125rem solid ${ink.inkNonEssential};`}
`;

export const DropdownList = styled.div<{ isOpen: boolean; $searchBarEmpty: boolean }>`
z-index: 1;
  position: absolute;
  border: 0.063rem solid #ccc;
  max-height: 24rem;
  overflow-y: auto;
  background: ${color.white}
  width: 100%;
  width: 22.375rem;
  border-radius: 0.5rem;
  border: 0.125rem solid ${ink.inkNonEssential};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: 0;
  display: ${({ isOpen, $searchBarEmpty }) => (isOpen && !$searchBarEmpty ? "block" : "none")};

  ${mobile} {
    width: 100%;
  }
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  cursor: pointer;
  background: ${color.white};
  color: ${ink.inkBase};

  font-size: 1.25rem;
  line-height: 2rem;
  letter-spacing: 0.075rem;

  &:hover {
    background: #fbfbfb;
  }
`;

export const Flag = styled.img`
  width: 2rem;
  height: 1.5rem;
  margin-right: 1rem;
`;

export const DropdownIcon = styled(Image)`
  position: absolute;
  right: 1.5rem;
  top: 1.4rem;
  cursor: pointer;

  ${mobile} {
    position: absolute;
    right: 2rem;
    top: 1.4rem;
    cursor: pointer;
  }
`;

export const DropdownArrow = styled(DropdownIcon)<{ $dropdownOpen: boolean }>`
  transition: transform 0.2s ease;
  transform: ${(p) => (p.$dropdownOpen ? "rotate(180deg)" : "none")};
`;

export const InputFlag = styled.img`
  position: absolute;
  left: 1.5rem;
  top: 1.2rem;
  width: 2rem;
  height: 1.5rem;
`;
